const appInfo = {
  title: 'Matrix Web',
};
export default appInfo;
